<script lang="ts" setup>
import { computed } from 'vue';
import { $fetch } from '@/plugins/fetch';
import { useAsyncData } from '@/hooks/async-data';
// import InfiniteMarquee from '@/components/InfiniteMarquee.vue';
import CountTo from '@/components/CountTo.vue';

const { data: globalConfig } = useAsyncData('home:project:config', () => $fetch('/web/openatom/config/v1/getone'));
// const { data: infoList } = useAsyncData('home:info', () => $fetch('/statistic/v1/major'));
const { data: graduatedList } = useAsyncData<Record<string, any>[]>(
  'home:project:graduated',
  () => $fetch('/project/v1/list', {
    data: {
      status: 3,
      limit: 500,
    },
  }),
);
const { data: incubateList } = useAsyncData<Record<string, any>[]>(
  'home:project:incubate',
  () => $fetch('/project/v1/list', {
    data: {
      status: 2,
      limit: 500,
    },
  }),
);
// const { data: donateList } = useAsyncData('home:donate', () => $fetch('/project/v1/list', { data: { status: 1 } }));

// const filteredIncubateList = computed(() => {
//   if (!incubateList.value) {
//     return [];
//   }

//   return incubateList.value.filter(item => {
//     return item.detailLogo !== null && item.detailLogo !== undefined && item.detailLogo !== '';
//   });
// });

// const donateMarqueeList = computed(() => [
//   donateList.value?.slice(0, 3) ?? [],
//   donateList.value?.slice(3, 6) ?? [],
// ]);

const projectList = computed(() => {
  return [...(graduatedList.value || []), ...(incubateList.value || [])];
});

const processValue = (value: string) => {
  const numValue = Number(value);

  if (isNaN(numValue)) {
    return 0;
  }

  if (numValue >= 100000) {
    return (numValue / 10000);
  }

  return numValue;
};

const getSuffix = (value: string) => {
  const numValue = Number(value);

  if (isNaN(numValue)) {
    return '';
  }

  if (numValue >= 100000) {
    return '万+';
  }

  return '+';
};
</script>

<template>
  <section class="page-home-projects">
    <div class="mx-auto max-w-1200 py-100 <md:py-40 <sm:px-16 <xl:px-24">
      <div class="flex items-center justify-between gap-x-90 <md:flex-wrap <md:gap-x-0 <md:gap-y-24">
        <h2 class="relative m-0 text-40 text-#292D33 font-600 leading-56 after:absolute after:bottom--16 after:left-0 after:right-0 after:h-4 after:bg-#1281FF after:content-empty <md:order-1 <md:text-28 <md:leading-36">
          {{ $t('home.exploreProjects.ourProject') }}
        </h2>
        <div class="flex flex-grow justify-between <md:order-3 <md:w-full *:flex-shrink-0">
          <div class="flex-y-center gap-x-24 <md:gap-x-12">
            <div class="text-56 text-#1281FF font-800 leading-74 <md:text-36 <md:leading-44">
              <CountTo
                :end-val="processValue(globalConfig.configInfo.project.number1)"
                :suffix="getSuffix(globalConfig.configInfo.project.number1)"
                v-if="globalConfig?.configInfo.project"
              />
            </div>
            <div class="mt-10 truncate whitespace-pre-wrap text-18 text-#9497A1 font-400 leading-30 <md:text-14">
              {{ $t('home.info.numberIntroduce1') }}
            </div>
          </div>
          <div class="flex-y-center gap-x-24 <md:gap-x-12">
            <div class="text-56 text-#1281FF font-800 leading-74 <md:text-36 <md:leading-44">
              <CountTo
                :end-val="processValue(globalConfig.configInfo.project.number2)"
                :suffix="getSuffix(globalConfig.configInfo.project.number2)"
                v-if="globalConfig?.configInfo.project"
              />
            </div>
            <div class="mt-10 truncate whitespace-pre-wrap text-18 text-#9497A1 font-400 leading-30 <md:text-14">
              {{ $t('home.info.numberIntroduce2') }}
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-between flex-self-stretch <md:contents">
          <div class="text-16 text-#9497A1 font-400 leading-30 <md:order-4 <md:w-full <md:text-center">{{ $t('home.exploreProjects.desc1') }}</div>
          <RouterLink to="/projects" class="flex-y-center flex-shrink-0 justify-end gap-x-8 text-16 text-#1281FF font-500 no-underline <md:order-2 <md:ml-auto">
            <span>{{ $t('home.exploreProjects.allItems') }}</span>
            <span class="i-home-icons:arrow-right-2 block size-24"></span>
          </RouterLink>
        </div>
      </div>

      <div class="mx-auto mt-32 w-1110 flex flex-wrap <md:w-full">
        <template v-for="item in projectList" :key="item.id">
          <template v-if="item.projectDownload">
            <a :href="item.projectDownload" target="_blank" class="block h-132 w-185 p-15 no-underline <md:w-1/3">
              <template v-if="item.detailLogo || item.cardLogo">
                <img :data-src="item.detailLogo || item.cardLogo" class="lazyload block size-full object-contain" :alt="item.title">
              </template>
              <template v-else>
                <div class="h-full w-full flex-center overflow-auto break-anywhere text-center text-22 text-#2D3339 font-bold">
                  {{ item.title }}
                </div>
              </template>
            </a>
          </template>
          <template v-else>
            <div class="h-132 w-185 p-15 <md:w-1/3">
              <template v-if="item.detailLogo || item.cardLogo">
                <img :data-src="item.detailLogo || item.cardLogo" class="lazyload block size-full object-contain" :alt="item.title">
              </template>
              <template v-else>
                <div class="h-full w-full flex-center overflow-auto break-anywhere text-center text-22 text-#2D3339 font-bold">
                  {{ item.title }}
                </div>
              </template>
            </div>
          </template>
        </template>
      </div>

      <!-- <div class="mt-32">
        <InfiniteMarquee v-for="(item, index) in donateMarqueeList" :key="index" :speed="40" :reverse="index % 2 ? true : false" class="not-first:mt-40">
          <div v-for="piece in item" :key="piece.id" class="group mx-20 h-134 w-348 flex-center border-1 border-#D6DDEB rounded-8 border-solid hover:bg-#1281FF">
            <RouterLink :to="`/project/${piece.id}`" class="block size-full p-32 no-underline">
              <h3 class="my-0 truncate text-24 text-#2D3339 font-500 leading-1.2em group-hover:text-white" :title="piece.title">
                {{ piece.title }}
              </h3>
              <p class="my-0 mt-12 flex-y-center justify-between gap-x-8 text-18 font-400 leading-1.6em" :title="piece.projectValue">
                <span class="truncate text-#4C5763 group-hover:text-white">{{ piece.projectValue }}</span>
                <span class="i-home-icons:arrow-right-2 block size-24 flex-shrink-0 text-#2D3339 group-hover:text-white"></span>
              </p>
            </RouterLink>
          </div>
        </InfiniteMarquee>
      </div> -->
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
